import { showSnackbar } from 'containers/Snackbar/actions';
import messages from 'containers/App/messages';

import {
    openLoadingOverlay,
    closeLoadingOverlay,
} from 'containers/LoadingOverlay/actions';
import { updateMerchant } from 'containers/App/actions';

import {
    LOAD_PRODUCTS_REQUEST,
    LOAD_PRODUCTS_SUCCESS,
    LOAD_PRODUCTS_ERROR,
} from './constants';
import { API_URI } from '../../config';

export function loadProductsRequest() {
    return {
        type: LOAD_PRODUCTS_REQUEST,
    };
}

export function loadProductsSuccess(result) {
    return {
        type: LOAD_PRODUCTS_SUCCESS,
        result,
    };
}

export function loadProductsError(error) {
    return {
        type: LOAD_PRODUCTS_ERROR,
        error,
    };
}

export function loadMerchantDetails(merchantId, showErrorIfNotFound = true) {
    return dispatch => {
        dispatch(loadProductsRequest());
        dispatch(openLoadingOverlay());

        const url = new URL(`/api/public/merchant/${merchantId}`, API_URI).toString();

        fetch(url)
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    return response.json()
                        .then(json => Promise.reject(json));
                }
            })
            .then(json => {
                const {
                    products,
                    categories,
                    productOptionGroups,
                    productOptions,
                    ...merchant
                } = json;
                dispatch(loadProductsSuccess({
                    products,
                    categories,
                    productOptionGroups,
                    productOptions,
                }));
                dispatch(updateMerchant(merchant));
                dispatch(closeLoadingOverlay());
            })
            .catch(error => {
                console.log(error);
                if (error.message.toLowerCase() !== 'merchant not found'
                    || (error.message.toLowerCase() === 'merchant not found' && showErrorIfNotFound)) {
                    dispatch(showSnackbar(messages.errorLoading));
                    dispatch(loadProductsError(error));
                }
                dispatch(closeLoadingOverlay());
            });
    };
}
